<p-dialog modal=true [(visible)]="exibirModalResponsabilidade" header="Aviso" width="425" [closable]="false">
  <p>
    Prezado usuário, seu anúncio será submetido a um filtro previamente à sua publicação. Anúncios ilícitos ou imorais serão rejeitados, podendo o responsável ser acionado nas esferas administrativas, cíveis e criminais.
  </p>
  <p-footer>
    <button type="button" pButton icon="pi pi-check" label="Estou ciente" class="ui-button-success button-dialog" (click)="fecharModalResponsabilidade()"></button>
  </p-footer>
</p-dialog>
